<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="filters.value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="currentPage=1,getCashout()">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="提现机构"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="提现金额"
          prop="money">
        </el-table-column>
        <el-table-column
          label="申请时间"
          :formatter="formatDate"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="审核人"
          prop="checkName">
        </el-table-column>
        <el-table-column
          :formatter="formatDate"
          label="上传时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="text" v-if="scope.row.state ==0" @click="handleEdit(scope.row.id)">通过</el-button>
            <span v-if="scope.row.state ==2">已通过</span>
            <span v-if="scope.row.state ==1">已拒绝</span>
            <span v-if="scope.row.state ==5">已拒绝</span>
            <span v-if="scope.row.state ==6">已拒绝</span>
            <span v-if="scope.row.state ==3">转账处理中</span>
            <span v-if="scope.row.state ==4">支付失败</span>
            <el-button size="mini" type="text" v-if="scope.row.state ==3" @click="handleSpeed(scope.row.id)">进度查询</el-button>
            <el-button size="mini" type="text" v-if="scope.row.state ==4" @click="handleReason(scope.row.id)">失败原因</el-button>
            <el-button size="mini" type="text" v-if="scope.row.state ==1 || scope.row.state ==5 || scope.row.state ==6" @click="handleRemarks(scope.row.id)">备注</el-button>
            <el-button size="mini" type="text" v-if="scope.row.state ==0" @click="handleRefuse(scope.row.id)">拒绝</el-button>
            <el-button size="mini" type="text" v-if="scope.row.state ==4" @click="handleEdit(scope.row.id)">重试</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="拒绝确认"  :visible.sync="addFormVisible" v-loading="loading">
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="分类名称" prop="name">
          <span>请输入您的拒绝理由</span>
        </el-form-item>
        <el-form-item label="分类排序" prop="name">
          <el-input
            type="textarea"
            :rows="5"
            maxlenth="1000"
            v-model="addForm.textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="addSubmit()" >提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提现失败"  :visible.sync="addFormVisible2" v-loading="loading">
      <el-form :model="addForm" ref="addForm">
        <el-form-item>
          <span style="font-size:18px;font-weight: bold;text-align: center;display: block;">提现失败</span>
        </el-form-item>
        <el-form-item>
          <span style="font-weight: 400;text-align: center;display: block;">{{remark}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible2=false">取消</el-button>
        <el-button type="primary" @click="addFormVisible2=false" >确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提现进度"  :visible.sync="addFormVisible3" v-loading="loading">
      <el-form :model="addForm" ref="addForm">
        <el-form-item>
          <span style="font-size:18px;font-weight: bold;text-align: center;display: block;">提现进度</span>
        </el-form-item>
        <el-form-item>
          <span style="font-weight: 400;text-align: center;display: block;">{{speed}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible3=false">取消</el-button>
        <el-button type="primary" @click="addFormVisible3=false" >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getCashout,editCashout,getCashoutDetail,getSpeed } from "../api/api"
  import { formatDate } from "../api/formatDate"
  export default {
    data () {
      return {
        filters: {
          value: '',
          name: ''
        },
        addForm:{
          textarea:''
        },
        options:[{
          value: ' ',
          label: '全部',
        }, {
          value: '0',
          label: '审核中',
        }, {
          value: '1',
          label: '已拒绝',
        }, {
          value: '2',
          label: '已通过',
        }],
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        codedata:[],
        addFormVisible:false,
        addFormVisible2:false,
        addFormVisible3:false,
        loading:false,
        id:'',
        remark:'',
        speed:''
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate(value) {
        var date = new Date(value.createTime*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      },
      getCashout(){
        getCashout({
          pageNum:this.currentPage,
          pageSize:this.limit,
          state :this.filters.value,
          userName:this.filters.name,
        }).then(res=>{
          this.total = res.data.total
          this.tableData = res.data.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      handleEdit(id){
        editCashout({
          id:id,
          state:2,
          remark:''
        }).then(res=>{
          if(res.code == -1){
            this.$message({
              type: 'error',
              message: res.data
            });
          }else{
            this.$message({
              type: 'success',
              message: res.msg
            });
          }
          this.getCashout()
        }).catch(error=>{
          console.log(error);
        })
      },
      handleReason(id){
        this.addFormVisible2 = true
        getCashoutDetail({
          id:id
        }).then(res=>{
          this.remark = res.data.failDesc
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRemarks(id){
        this.addFormVisible2 = true
        getCashoutDetail({
          id:id
        }).then(res=>{
          this.remark = res.data.remark
        }).catch(error=>{
          console.log(error);
        })
      },
      handleSpeed(id){
        this.addFormVisible3 = true
        getSpeed({
          id:id
        }).then(res=>{
          this.speed = res.data
          this.getCashout()
        }).catch(error=>{
          console.log(error);
        })
      },
      handleRefuse(id){
        this.addFormVisible = true
        this.id = id
      },
      addSubmit(){
        editCashout({
          id:this.id,
          state:1,
          remark:this.addForm.textarea
        }).then(res=>{
          this.$message({
            type: 'success',
            message: res.msg
          });
          this.addFormVisible = false
          this.getCashout()
        }).catch(error=>{
          console.log(error);
        })
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.getCashout()
      },
      cancel(){
        this.addFormVisible = false
        this.addForm.textarea=''
      }
    },
    created (){
      this.getCashout()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>




// WEBPACK FOOTER //
// src/page/reflect.vue